import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import TeacherPayoutReports from 'src/mentor/components/TeacherPayoutReports/TeacherPayoutReports'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { getMinimalMentorData } from 'src/supportPortal/views/therapists/util'

export default function TherapistPayoutReports() {
  const { mentorSlug } = useParams()
  const [loading, setLoading] = useState(false)
  const [currentTherapist, setCurrentTherapist] = useState()
  const [associatedClinics, setAssociatedClinics] = useState([])
  const [allEventTypes, setAllEventTypes] = useState([])

  async function getSelectedTherapist() {
    const resp = await getMinimalMentorData(
      mentorSlug,
      true,
      `/api/secure/cc/support/therapists/by-slug?mentor-slug=${mentorSlug}`,
    )
    setCurrentTherapist(resp)
  }

  async function getAllEventTypes() {
    const resp = await getSPDataWithParams(`/api/secure/cc/support/reference/event-types`, {})
    if (resp.status === 200) {
      setAllEventTypes(resp?.data?.sort((a, b) => a?.title?.localeCompare(b?.title)))
    }
  }

  async function getAssociatedBrands() {
    const resp = await getSPDataWithParams(
      '/api/secure/cc/support/therapists/clinic-associations',
      { 'mentor-slug': mentorSlug },
      undefined,
      undefined,
      true,
    )
    if (resp && isCommonResponseSuccessfulV2(resp)) {
      const dat = getDataMapFromCommonResponse(resp)?.clinic
      setAssociatedClinics(dat)
    }
  }
  async function setup() {
    setLoading(true)
    await Promise.all([getSelectedTherapist(), getAssociatedBrands(), getAllEventTypes()])
    setLoading(false)
  }
  useEffect(() => {
    setup()
  }, [])

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader
        heading={`${currentTherapist?.firstName} Payout Reports`}
        // subHeading="View and download clinic payout reports"
      />
      {currentTherapist ? (
        <TeacherPayoutReports
          reportListApiSignature={'/api/secure/cc/support/payout-reports/mentor/paginated'}
          summaryReportApiSignature={'/api/secure/cc/support/payout-reports/mentor/summary'}
          allEventTypes={allEventTypes}
          reportsListingApiParams={{
            'teacher-id': currentTherapist?.id,
          }}
          summaryReportApiParams={{
            'teacher-id': currentTherapist?.id,
          }}
          bookedEventLogApiUrl="/api/secure/cc/support/events/logs/get"
          // eventType={eventType}
          //   thisClinicBrandData={selectedClinicBrand}
          hideBackButton
          showSummaryReport
          useLocalDateFormatForApiCalls
          clinicAssociationData={associatedClinics}
          showAdminActions
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100 w-100">
          <CircularProgress />
        </div>
      )}
    </div>
  )
}
